<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "CustomerCTIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
